import { minWordsRule } from "@core/shared/utils";
import { maxLengthRule, minLengthRule, patternRule, requiredRule } from "@mongez/react-form";
import { BaseInput, type BaseInputProps } from "./BaseInput";

export type TextInputProps = BaseInputProps & {
  minLength?: number;
  maxLength?: number;
  length?: number;
};

export function TextInput(props: TextInputProps) {
  return (
    <BaseInput
      rules={[requiredRule, minLengthRule, maxLengthRule, patternRule, minWordsRule]}
      {...props}
      type="text"
    />
  );
}
